import { Icon } from "@mindlercare/ui-web";
import { useRef } from "react";
import { AriaButtonProps, useButton } from "react-aria";
import { styled } from "styled-components";

export const ChevronLeftButton = (props: AriaButtonProps) => (
  <ChevronLeftButtonContainer>
    <ChevronButton {...props} />
  </ChevronLeftButtonContainer>
);

export const ChevronRightButton = (props: AriaButtonProps) => (
  <ChevronRightButtonContainer>
    <ChevronButton {...props} />
  </ChevronRightButtonContainer>
);

const ChevronButton = (props: AriaButtonProps) => (
  <IconButton {...props}>
    <Icon.ChevronLeft />
  </IconButton>
);

const IconButton = (props: AriaButtonProps) => {
  const ref = useRef(null);
  const { buttonProps } = useButton(props, ref);

  return (
    <StyledIconButton {...buttonProps} ref={ref}>
      {props.children}
    </StyledIconButton>
  );
};

const ChevronLeftButtonContainer = styled.div`
  vertical-align: center;
`;

const ChevronRightButtonContainer = styled(ChevronLeftButtonContainer)`
  transform: rotate(180deg);
`;

const StyledIconButton = styled.button`
  margin: 0 ${({ theme }) => theme.MARGIN.MD} 0
    ${({ theme }) => theme.MARGIN.MD};
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.MARGIN.SM};
  border-radius: 50%;

  &:enabled {
    &:hover {
      background-color: ${({ theme }) => theme.COLORS.RIPPLE};
    }
  }

  &:disabled {
    cursor: initial;
    fill: ${({ theme }) => theme.COLORS.GRAY};
    background-color: none;
  }
`;
